<script setup>
import ButtonSubmit from "./ButtonSubmit.vue";
import DescriptionInline from "./DescriptionInline.vue";
import DropDownInfo from "./DropDownInfo.vue";
import api from "../api/api";
import FileUploader from "./FileUploader.vue";
import Multiselect from "@vueform/multiselect";
import Swal from "sweetalert2";
import BulkUserUploadReports from "./BulkUserUploadReports.vue";
import CryptoJS from "crypto-js";
import { flashMessage } from "../functions.js";
</script>

<template>
  <div>
    <!-- Loading Overlay -->
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-content">
        <div class="spinner"></div>
        <p class="loading-message">{{ loadingMessage }}</p>
      </div>
    </div>

    <div class="form-container">
        <form @submit.prevent="swalValidation" method="post">
        <div v-if="passedUserData.roles.includes('16')">
          <label style="color: #ccc" for="selectOrganisation"
            ><DescriptionInline label="Your organization"
          /></label>
          <select
            class="input input-outlined"
            id="selectOrganisation"
            name="organization"
            v-model="userDetails.org_id"
            required
          >
            <option :value="null" selected>Select Organisation</option>
            <option
              v-for="org in userOrg"
              v-bind:key="org.org_id"
              v-bind:value="org.org_id"
            >
              {{ org.org_name }}
            </option>
          </select>
        </div>

        <div v-else>
          <label style="color: #ccc" for="organization"
            ><DescriptionInline label="Your organization"
          /></label>
          <p id="organization">{{ userOrgName }}</p>
        </div>

        <label style="color: #ccc" for="selectSubOrganisation">
          <DescriptionInline label="Select sub-organisation " />
        </label>
        <Multiselect
          v-model="userDetails.suborgs"
          class="input1 input-outlined"
          placeholder="Select sub-organization"
          :searchable="true"
          :options="filteredSubOrg"
          :allow-empty="true"
        />

        <label style="color: #ccc" for="selectProgram">
          <DescriptionInline label="Select Program" />
        </label>
        <Multiselect
          v-model="userDetails.indGroup.program_id"
          class="input1 input-outlined"
          placeholder="Select/Add program"
          :searchable="true"
          :options="filteredProgram"
          :createOption="true"
          :allow-empty="true"
        />

        <label style="color: #ccc" for="selectIteration">
          <DescriptionInline label="Select Iteration" />
        </label>
        <Multiselect
          v-model="userDetails.indGroup.iteration_id"
          class="input1 input-outlined"
          placeholder="Select/Add iteration"
          :searchable="true"
          :options="filteredIteration"
          :createOption="true"
          :allow-empty="true"
        />

        <input
          type="radio"
          id="email-notif"
          name="emailNotif"
          v-model="emailNotif"
          value="true"
        />
        <label for="email-notif">Send Email Notification</label><br />

        <div v-if="emailNotif" class="radio-btn">
          <input
            type="radio"
            id="date-now"
            name="initiation_date"
            :value="currentDate.toISOString().slice(0, -8)"
            v-model="userDetails.initiation_date"
            @click="hideCalendar"
          />
          <label for="date-now">Now</label><br />

          <input
            type="radio"
            id="later-date"
            name="initiation_date"
            value="true"
            v-model="sendLater"
            @click="clearDate"
          />
          <label for="later-date" style="margin-right: 5px">Later</label>

          <input
            v-if="sendLater"
            type="datetime-local"
            id="launch"
            v-model="userDetails.initiation_date"
            @input="initiation = $event.target.value"
          />
        </div>

        <FileUploader
          :onSubmit="onFileSubmit"
          :key="renderComponent"
          ref="file"
        />
        <br>
        <ButtonSubmit
          type="submit"
          value="Submit"
          :label="buttonLabel"
          :disabled="disable == true"
        />
        <br /><br />
      </form>
    </div>

    <BulkUserUploadReports
      :passParseData="passParseData"
      :existingEmailData="existingEmailData"
    />
    <ButtonSubmit
      label="Upload Again"
      v-show="toggle == false"
      @click="resetComponent"
    />
  </div>
</template>

<script>
export default {
  name: "BulkUploadUserBox",
  component: [
    DescriptionInline,
    DropDownInfo,
    FileUploader,
    ButtonSubmit,
    Multiselect,
    BulkUserUploadReports,
  ],
  props: ["buttonLabel", "passedUserData", "brandData"],

  data: () => ({
    renderComponent: 0,
    toggle: true,
    disable: false,
    mode: "tags",
    closeOnSelect: false,
    searchable: true,
    file: null,
    formData: "",
    timezone: "Select time-zone",
    userOrg: [],
    userSubOrg: [],
    userRoles: {},
    newRoleId: "",
    csvRole: "",
    suborgOptions: [],
    userIterations: [],
    userPrograms: [],
    statement: [],
    userData: [],
    userOrgName: "",
    parseData: [],
    passParseData: [],
    existingEmailData: [],
    currentDate: new Date(),
    emailNotif: false,
    sendLater: false,
    isLoading: false,
    loadingMessage: "Loading...",
    userDetails: {
      org_id: null,
      suborgs: [],
      initiation_date: null,
      auth_string: "",
      seed: "",
      program: {
        program_name: "",
        org_id: null,
        suborg_id: null,
        created_by: "1",
        modified_by: "1",
      },
      iteration: {
        iteration_name: "",
        org_id: null,
        suborg_id: null,
        program_id: null,
        created_by: "1",
        modified_by: "1",
      },
      indGroup: {
        ind_id: null,
        program_id: null,
        iteration_id: null,
        org_id: null,
        suborg_id: null,
        created_by: "1",
        modified_by: "1",
      },
    },
    userAuthStringResult:
      "000000000000000000000000000000000000000000000000000000000000", // 59 items
    userAuthString: {
      Participant:
        "111111111100000000000000000000000000000000000000000000000000",
      Respondent: "111111111100000000000000000000000000000000000000000000000000",
      SurveyPreviewer:
        "111111111100100000000000000000000000000000000000000001000000",
      Coach: "111111111100010000000001000111111111111111111111000001000000",
      FacultyViewer:
        "111111111100000000000000000111111011111111111110000001000000",
      HRProfessionalViewer:
        "111111111100000000000000000111111111111111111110000001000000",
      ClientAdministratorViewer:
        "111111111100000000000000000111111011111111111110000001000010",
      ClientAdministratorEditor:
        "111111111100111111111111111111111011111111111111001001000000",
      ClientEmailTemplateEditor:
        "111111111110111111111111111111111011111111111111001001000000",
      CXM: "111111111100111111111110001111111011111111111111001001000000",
      MasterAdministrator:
        "111111111100111111111111111111111111111111111111111001000000",
      MasterAdministratorEmails:
        "111111111110111111111111111111111111111111111111111001000000",
      SubOrgManager:
        "111111111110111111111111111111111111111111111111111101000100",
      AnnouncementManager:
        "111111111111111111111111111111111111111111111111111101000100",
      SiteManager:
        "100000000000011000000000100000000000000000000000000010100001",
      SurveyCreator:
        "100000000000000000000000000000000000000000000000000000010001",
      SurveyManager:
        "100000000000000000000000000000000000000000000000000000011001",
    },
  }),
  async mounted() {
    this.isLoading = true;
    this.loadingMessage = "Loading your organization details...";

    if (this.passedUserData != "undefined" || this.passedUserData != null) {
      if (this.passedUserData.roles.includes("16")) {
        await api
          .get("individuals/" + this.passedUserData.ind_id)
          .then((result) => {
            this.userOrgName = result.data.org_name;
            this.userDetails.org_id = this.passedUserData.org_id;
          });
      } else {
        await api
          .get("individuals/" + this.passedUserData.ind_id)
          .then((result) => {
            this.userOrgName = result.data.org_name;
            this.userDetails.org_id = this.passedUserData.org_id;
          });
      }
    }

    this.loadingMessage = "Loading organizations and programs...";
    await this.renderDataAgain();

    this.loadingMessage = "Loading organizations...";
    await api.get("organizations").then((result) => {
      this.userOrg = result.data.sort((a, b) =>
        a.org_name.localeCompare(b.org_name)
      );
    });

    this.loadingMessage = "Loading user roles...";
    await api.get("roles/").then((result) => {
      this.userRoles = result.data;
    });

    this.loadingMessage = "Loading sub-organizations...";
    await api.get("sub-organizations/").then((result) => {
      this.userSubOrg = result.data;
    });

    this.isLoading = false;
  },
  methods: {
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    encrypt(src, passphrase) {
      return CryptoJS.AES.encrypt(src, passphrase).toString();
    },
    clearDate() {
      this.userDetails.initiation_date = "";
    },

    async renderDataAgain() {
      // Execute all API calls in parallel instead of sequentially
      const [individualsResult, iterationsResult, programsResult] = await Promise.all([
        api.get("individuals"),
        api.get("iterations"),
        api.get("programs")
      ]);

      this.userData = individualsResult.data;
      this.userIterations = iterationsResult.data;
      this.userPrograms = programsResult.data;
    },

    resetComponent() {
      // No need for loading spinner or API calls - just reset the form state
      if (this.passedUserData.roles.includes("16")) {
        this.userDetails.org_id = null;
      }
      this.userDetails.suborgs = [];
      this.toggle = true;
      this.passParseData = [];
      this.existingEmailData = [];
      
      // Data is already loaded from mounted() - no need to fetch again
      
      this.renderComponent = 0;
      this.disable = false;
    },

    hideCalendar() {
      this.sendLater = false;
    },

    onFileSubmit: async function (file) {
      const reader = new FileReader();

      reader.readAsText(file);

      reader.onload = () => {
        this.file = reader.result;
      };

      reader.onerror = () => {};
    },

    swalValidation() {
      if (
        this.userDetails.indGroup.program_id == null &&
        this.userDetails.indGroup.iteration_id == null
      ) {
        try {
          Swal.fire({
            text: `Are you sure you want to leave program and iteration blank?`,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.isConfirmed) {
              var vm = this;
              this.$papa.parse(this.file, {
                header: true,
                delimiter: ",",
                skipEmptyLines: true,
                complete: function (results) {
                  vm.passParseData = results.data;
                  const parseData = results.data;
                  const tempEmails = vm.userData.map((x) =>
                    x.email.toLowerCase()
                  );
                  vm.parseData = parseData.filter(
                    (x) => !tempEmails.includes(x.email.toLowerCase())
                  );
                  vm.existingEmailData = parseData.filter((x) =>
                    tempEmails.includes(x.email.toLowerCase())
                  );
                },
              });
              vm.handleSubmit();
            }
          });
        } catch (error) {
          console.error(error);
        }
      } else if (
        this.userDetails.indGroup.program_id != null &&
        this.userDetails.indGroup.iteration_id == null
      ) {
        try {
          Swal.fire({
            text: `Are you sure you want to leave iteration blank?`,
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Yes",
          }).then((result) => {
            if (result.isConfirmed) {
              var vm = this;
              this.$papa.parse(this.file, {
                header: true,
                delimiter: ",",
                skipEmptyLines: true,
                complete: function (results) {
                  vm.passParseData = results.data;
                  const parseData = results.data;
                  const tempEmails = vm.userData.map((x) =>
                    x.email.toLowerCase()
                  );
                  vm.parseData = parseData.filter(
                    (x) => !tempEmails.includes(x.email.toLowerCase())
                  );
                  vm.existingEmailData = parseData.filter((x) =>
                    tempEmails.includes(x.email.toLowerCase())
                  );
                },
              });
              vm.handleSubmit();
            }
          });
        } catch (error) {
          console.error(error);
        }
      } else if (
        this.userDetails.indGroup.program_id == null &&
        this.userDetails.indGroup.iteration_id != null
      ) {
        try {
          Swal.fire({
            text: `You cannot leave program blank.`,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Ok",
          }).then((result) => {
            if (result.isConfirmed) {
              this.userDetails.indGroup.iteration_id = null;
            }
          });
        } catch (error) {
          console.error(error);
        }
      } else {
        try {
          var vm = this;
          this.$papa.parse(this.file, {
            header: true,
            delimiter: ",",
            skipEmptyLines: true,
            complete: function (results) {
              vm.passParseData = results.data;
              const parseData = results.data;
              vm.parseData = parseData;
              vm.existingEmailData = parseData;
            },
          });
          vm.handleSubmit();
        } catch (error) {
          console.error(error);
        }
      }
    },

    handleSubmit() {
      try {
        this.isLoading = true;
        this.loadingMessage = "Processing users, please wait...";

        var userDetails = this.userDetails;
        var indGroup = this.userDetails.indGroup;
        var userAuthString = this.userAuthString;
        var newRoleId = this.newRoleId;
        var userRoles = this.userRoles;
        const data = this.parseData;
        
        let uploadedCount = 0;
        const totalUsers = data.length;

        for (var j = 0; j < data.length; j++) {
          // CRITICAL: Reset userAuthStringResult for each user to prevent cumulative permissions
          let userAuthStringResult = "000000000000000000000000000000000000000000000000000000000000";
          
          this.userDetails.seed = this.randomString(
            32,
            "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
          );
          
          // Process role and set auth string based on role type
          if (data[j].role && data[j].role.toLowerCase() == "participant") {
            userAuthStringResult = userAuthString.Participant;
          } else if (data[j].role && data[j].role.toLowerCase() == "respondent") {
            userAuthStringResult = userAuthString.Respondent;
          } else if (data[j].role && data[j].role.toLowerCase() == "survey previewer") {
            userAuthStringResult = userAuthString.SurveyPreviewer;
          } else if (data[j].role && data[j].role.toLowerCase() == "coach") {
            userAuthStringResult = userAuthString.Coach;
          } else if (data[j].role && data[j].role.toLowerCase() == "faculty viewer") {
            userAuthStringResult = userAuthString.FacultyViewer;
          } else if (data[j].role && data[j].role.toLowerCase() == "hr professional viewer") {
            userAuthStringResult = userAuthString.HRProfessionalViewer;
          } else if (data[j].role && data[j].role.toLowerCase() == "client administrator viewer") {
            userAuthStringResult = userAuthString.ClientAdministratorViewer;
          } else if (data[j].role && data[j].role.toLowerCase() == "client adminsitrator editor") {
            userAuthStringResult = userAuthString.ClientAdministratorEditor;
          } else if (data[j].role && data[j].role.toLowerCase() == "client email template") {
            userAuthStringResult = userAuthString.ClientEmailTemplateEditor;
          } else if (data[j].role && data[j].role.toLowerCase() == "cxm") {
            userAuthStringResult = userAuthString.CXM;
          } else if (data[j].role && data[j].role.toLowerCase() == "master administrator") {
            userAuthStringResult = userAuthString.MasterAdministrator;
          } else if (data[j].role && data[j].role.toLowerCase() == "master administrator - emails") {
            userAuthStringResult = userAuthString.MasterAdministratorEmails;
          } else if (data[j].role && data[j].role.toLowerCase() == "sub org manager") {
            userAuthStringResult = userAuthString.SubOrgManager;
          } else if (data[j].role && data[j].role.toLowerCase() == "announcement manager") {
            userAuthStringResult = userAuthString.AnnouncementManager;
          } else if (data[j].role && data[j].role.toLowerCase() == "site manager") {
            userAuthStringResult = userAuthString.SiteManager;
          } else if (data[j].role && data[j].role.toLowerCase() == "survey creator") {
            userAuthStringResult = userAuthString.SurveyCreator;
          } else if (data[j].role && data[j].role.toLowerCase() == "survey manager") {
            userAuthStringResult = userAuthString.SurveyManager;
          }
          
          // Encrypt the auth string
          userDetails.auth_string = this.encrypt(
            userAuthStringResult,
            userDetails.seed
          );

          // Find the role ID
          newRoleId = "";
          userRoles.forEach((roles) => {
            if (data[j].role && data[j].role.toLowerCase() == roles.role_name.toLowerCase()) {
              newRoleId = roles.role_id;
            }
          });

          this.loadingMessage = `Uploading user ${j + 1} of ${totalUsers}...`;

          if (indGroup.program_id == null) {
            api
              .post("individuals/", {
                email: data[j].email,
                first_name: data[j].first_name,
                last_name: data[j].last_name,
                auth_string: userDetails.auth_string,
                seed: userDetails.seed,
                suppress_email_sending: 0,
                is_participant: 1,
                org_id: userDetails.org_id,
                suborgs: userDetails.suborgs,
                roles: newRoleId,
                initiation_date: userDetails.initiation_date,
                created_by: "1",
                modified_by: "1",
                indGroup: {
                  program_id: indGroup.program_id,
                  iteration_id: indGroup.iteration_id,
                  org_id: userDetails.org_id,
                  suborg_id: userDetails.suborgs,
                  created_by: indGroup.created_by,
                  modified_by: indGroup.modified_by,
                },
              })
              .then(() => {
                uploadedCount++;
                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#F47820",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  "Uploaded " + uploadedCount + " of " + totalUsers + " users"
                );
                if (uploadedCount === totalUsers) {
                  this.isLoading = false;
                }
              })
              .catch((e) => {
                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#F47820",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  e.message
                );
                this.isLoading = false;
              });
          } else {
            api
              .post("individuals-and-program/", {
                email: data[j].email,
                first_name: data[j].first_name,
                last_name: data[j].last_name,
                auth_string: userDetails.auth_string,
                seed: userDetails.seed,
                suppress_email_sending: 0,
                is_participant: 1,
                org_id: userDetails.org_id,
                suborgs: userDetails.suborgs,
                roles: newRoleId,
                initiation_date: userDetails.initiation_date,
                created_by: "1",
                modified_by: "1",
                program: {
                  program_name: indGroup.program_id,
                  org_id: userDetails.org_id,
                  suborg_id: userDetails.suborgs,
                  created_by: indGroup.created_by,
                  modified_by: indGroup.modified_by,
                },
                iteration: {
                  iteration_name: indGroup.iteration_id,
                  org_id: userDetails.org_id,
                  suborg_id: userDetails.suborgs,
                  created_by: "1",
                  modified_by: "1",
                },
                indGroup: {
                  org_id: userDetails.org_id,
                  suborg_id: userDetails.suborgs,
                  created_by: indGroup.created_by,
                  modified_by: indGroup.modified_by,
                },
              })
              .then(() => {
                uploadedCount++;
                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#F47820",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  "Uploaded " + uploadedCount + " of " + totalUsers + " users"
                );
                if (uploadedCount === totalUsers) {
                  this.isLoading = false;
                }
              })
              .catch((e) => {
                flashMessage(
                  this.$flashMessage,
                  this.brandData.accent_color1
                    ? this.brandData.accent_color1
                    : "#F47820",
                  this.brandData.flash_text_color
                    ? this.brandData.flash_text_color
                    : "#ffffff",
                  e.message
                );
                this.isLoading = false;
              });
          }
        }
        this.$forceUpdate();
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
      this.userDetails.indGroup.program_id = null;
      this.userDetails.indGroup.iteration_id = null;
      this.emailNotif = false;
      this.userDetails.initiation_date = null;
      this.sendLater = false;
      this.toggle = false;
      this.disable = true;
      this.renderComponent++;
    },
  },
  computed: {
    mapSubOrg: function () {
      return this.userSubOrg
        .sort((a, b) => a.suborg_name.localeCompare(b.suborg_name))
        .map(function (el) {
          if (
            this.userDetails.org_id != "" ||
            this.userDetails.org_id != undefined ||
            this.userDetails.org_id !== null
          ) {
            if (this.userDetails.org_id == el.org_id) {
              if (el.suborg_id != undefined || el.suborg_name != undefined) {
                return { value: el.suborg_id, label: el.suborg_name };
              }
            }
          }
        }, this);
    },

    filteredSubOrg: function () {
      return this.mapSubOrg.filter(function (el) {
        return el !== undefined;
      }, this);
    },

    mapProgram: function () {
      return this.userPrograms
        .sort((a, b) => a.program_name.localeCompare(b.program_name))
        .map(function (el) {
          if (
            this.userDetails.org_id != "" ||
            this.userDetails.org_id != undefined ||
            this.userDetails.org_id !== null
          ) {
            if (
              this.userDetails.org_id == el.org_id &&
              this.userDetails.suborgs == el.suborg_id
            ) {
              if (el.program_id != undefined || el.program_name != undefined) {
                return { value: el.program_id, label: el.program_name };
              }
            }
          } else {
            return "";
          }
        }, this);
    },

    filteredProgram: function () {
      return this.mapProgram.filter(function (el) {
        return el !== undefined;
      }, this);
    },

    mapIteration: function () {
      return this.userIterations
        .sort((a, b) => a.iteration_name.localeCompare(b.iteration_name))
        .map(function (el) {
          if (
            this.userDetails.org_id != "" ||
            this.userDetails.org_id != undefined ||
            this.userDetails.org_id !== null
          ) {
            if (
              this.userDetails.org_id == el.org_id &&
              this.userDetails.suborgs == el.suborg_id &&
              this.userDetails.indGroup.program_id == el.program_id
            ) {
              if (
                el.iteration_id != undefined ||
                el.iteration_name != undefined
              ) {
                return { value: el.iteration_id, label: el.iteration_name };
              }
            }
          } else {
            return "";
          }
        }, this);
    },

    filteredIteration: function () {
      return this.mapIteration.filter(function (el) {
        return el !== undefined;
      }, this);
    },
  },
};
</script>

<style scoped>
.form-container {
  background: white;
  padding: 50px;
  border-radius: 8px;
  max-width: 100%;
  width: 50%;
}

.radio-btn {
  margin-top: 5px;
}
.radio-btn input {
  margin-left: 20px;
}

.input {
  width: 100%;
  min-width: 250px;
  outline: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px 12px;
  margin: 5px 0px;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
}

.input:focus {
  border-color: #F47820;
  outline: none;
}

.box {
  border: 1px solid #ccc;
  border-top: 4px solid rgb(185, 22, 10);
  text-align: center;
  font: -webkit-control;
  margin: 0;
  padding: 10px;
  max-width: 100%;
  width: 100%;
  min-height: 400px;
}

.btn {
  width: 100%;
  background-color: #e67829;
}

.label1 {
  top: 0px;
  left: 0px;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  font-family: Arial, Helvetica, sans-serif;
}

.input1 {
  width: 100%;
  outline: 0;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 10px 12px;
  margin: 5px 0px;
}

.input1:focus {
  border-color: #F47820;
}

input, select, option, textarea {
  border: 1px solid #ccc;
  border-radius: 4px;
}

label {
  display: block;
  margin-top: 8px;
  margin-bottom: 3px;
  font-weight: 500;
  color: #333 !important;
}

/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  background-color: white;
  padding: 30px 40px;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.spinner {
  border: 4px solid rgba(244, 120, 32, 0.3);
  border-top: 4px solid #F47820;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin: 0 auto 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.loading-message {
  color: #333;
  font-size: 16px;
  font-weight: 500;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}
</style>